import { render, staticRenderFns } from "./purchaseOrder.vue?vue&type=template&id=50559da6&"
import script from "./purchaseOrder.vue?vue&type=script&lang=js&"
export * from "./purchaseOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports